// "Production" enabled environment

export const environment = {
    production: false,
    // envName: 'dev',
    hmr: false,
    appConfig: 'appconfig.json',
    GoogleTag: 'GTM-MPWF8FGT',
    GoogleClientId: '879001635616-ktqpsf12bbi55kh4ut8auvuio28bk0so.apps.googleusercontent.com',
    FacebookClientId: '3721145298155846',
    RecaptchSiteKey: "6LdH5FspAAAAADw0kIW5v05ZxicwYRu5Xe2g7tNE",
    ClickConnectorPaidUsersWidgetId: "4d9580-b1eea",
    ClickConnectorFreeUsersWidgetId: "4d9580-8a5bb",
    ServicesBaseUrl: "https://services.cablepro.elek.com",
    token: 'ZXvAKmvgrTYOkVais5rt0Ks88YLaCYRTvhPeS0rrFOgMZPsOYVtblvsXz7T3IQjS',
    cpwCheckApiStatusUrl: 'https://services.cablepro.elek.com/dev-ping/'
};
